'use client';

import { useEffect, useState } from 'react';
import { AbTest } from '@/app_components/common/AbTest';
import { Icon } from '@/app_components/common/Icon';
import { FortuneLogoSecondary } from '@/app_components/icons/logos/FortuneLogoSecondary';
import { trackOptimizelyEvent } from '@/app_lib/optimizely/utils';
import { useOptimizely } from '@/main/lib/hooks/useOptimizely';

const DISMISS_KEY = 'fortune-app-banner-dismissed';

const AppDownloadBannerContent = () => {
  const { optimizely } = useOptimizely();
  const [isDismissed, setIsDismissed] = useState(true);

  useEffect(() => {
    try {
      setIsDismissed(localStorage.getItem(DISMISS_KEY) === 'true');
    } catch {
      setIsDismissed(false);
    }
  }, []);

  const handleDismiss = () => {
    trackOptimizelyEvent(optimizely, 'download_app_banner_dismissed', {});
    setIsDismissed(true);
    try {
      localStorage.setItem(DISMISS_KEY, 'true');
    } catch {}
  };

  const handleGetAppClick = () => {
    trackOptimizelyEvent(optimizely, 'download_app_button_clicked', {});
  };

  if (isDismissed) {
    return null;
  }

  return (
    <div className='flex items-center gap-3 bg-gray-50 px-4 py-3'>
      <FortuneLogoSecondary className='size-8 shrink-0 rounded-xl' />
      <div className='flex min-w-0 flex-1 flex-col gap-1'>
        <span className='inline-flex w-fit items-center justify-center rounded-sm bg-blue-100 px-1 py-1 font-graphik-compact text-[10px] font-bold uppercase leading-none tracking-wide text-blue-700'>
          Beta
        </span>
        <p className='font-graphik-compact text-sm font-medium text-primary'>Download the Fortune app</p>
      </div>
      <div className='flex shrink-0 items-center gap-3'>
        <button
          className='button-primary button-text-primary inline-flex h-8 shrink-0 cursor-pointer items-center justify-center rounded-full px-5 text-sm font-medium'
          onClick={handleGetAppClick}
          type='button'
        >
          Get app
        </button>
        <button
          aria-label='Close banner'
          className='shrink-0 cursor-pointer'
          onClick={handleDismiss}
          type='button'
        >
          <Icon
            height={20}
            icon='X'
            strokeWidth={1.5}
            width={20}
          />
        </button>
      </div>
    </div>
  );
};

export const AppDownloadBanner = () => (
  <AbTest flagName='download_app_banner'>
    <AppDownloadBannerContent />
  </AbTest>
);
